import React from 'react';
import {graphql} from 'gatsby';

import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';
import SEO from '../components/seo';

const InstrumentPlusWokal = ({data}) => {

    console.log(data);
    const duetPhoto = data.duet.childImageSharp.fluid;
    const bglink = data.bg.childImageSharp.fluid;
    const titleText = "Instrument plus wokal";
    const paragraphText = "Lorem Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea "; 
  
    const content = [
      {
        title: "Stwórz duet własnych marzeń",
        text: "Jesteśmy rozbudowaną i doświadczoną na rynku eventowym firmą, która posiada własną agencję muzyków i artystów. Spełnimy Państwa oczekiwania tworząc duet dopasowany do Państwa gustu i potrzeb. Jeśli ma być jazzowo: stworzymy odpowiedni duet weselny, aby Państwa goście poczuli klimat spokoju i imprezy wysokiej kultury. Jeśli oczekują Państwo biesiady, na to też mamy gotowe pomysły! Napisz do nas aby dowiedzieć się więcej!",
        image: duetPhoto,
        alt: "Stwórz duet własnych marzeń"},
    ];

    return (
      <>
        <SEO title="Instrument plus wokal na wesele"/>
        <Header link={bglink}/>
        <SectionWrapper content={content} text={paragraphText} title={titleText} />
      </>
    )
};

export const query = graphql`
  {
    duet: file(name: {eq: "duet_marzen"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    bg: file(name: {eq: "Duet"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;


export default InstrumentPlusWokal